import React from "react";
import { ItemType } from "../../../clients/graphqlTypes.js";

export const SEARCH_PRODUCTS_OPTION_ID = "search_products";
export const SEARCH_PRODUCTS_FIS_SOLR_OPTION_ID = "search_products_fis_solr";
export const SEARCH_TEMPLATES_OPTION_ID = "search_templates";
export const SEARCH_PRODUCT_LISTS_OPTION_ID = "search_product_lists";
export const PASTE_OPTION_ID = "paste_from_clipboard";
export const TEMPLATE_OPTION_ID = "insert_from_template";
export const RECOMMENDATIONS_HEADER_OPTION_ID = "recommendations-header";

type OptionType<
  IsHeader extends boolean = false,
  IsText extends boolean = false,
  IsTemplate extends boolean = false,
  IsProduct extends boolean = false,
  IsRecommendation extends boolean = false,
  IsProductList extends boolean = false,
> = {
  isHeader?: IsHeader;
  isText?: IsText;
  isTemplate?: IsTemplate;
  isProduct?: IsProduct;
  isRecommendation?: IsRecommendation;
  isProductList?: IsProductList;
  title: string;
  Title?: React.ReactNode;
  hint?: string;
  icon?: React.ReactNode;
  inputValue?: string;
};

export type ItemTypeInputOption = OptionType & {
  id: ItemType;
};
export type SearchProductsOption = OptionType & {
  id: typeof SEARCH_PRODUCTS_OPTION_ID;
};
export type SearchProductsFisSolrOption = OptionType & {
  id: typeof SEARCH_PRODUCTS_FIS_SOLR_OPTION_ID;
};
export type SearchTemplatesOption = OptionType & {
  id: typeof SEARCH_TEMPLATES_OPTION_ID;
};
export type SearchProductListsOption = OptionType & {
  id: typeof SEARCH_PRODUCT_LISTS_OPTION_ID;
};
export type PasteOption = OptionType & {
  id: typeof PASTE_OPTION_ID;
};
export type TemplateOption = OptionType & {
  id: typeof TEMPLATE_OPTION_ID;
};
export type HeaderInputOption = OptionType<true> & {
  id: string;
  isLoading: boolean;
};
export type TextInputOption = OptionType<false, true> & {
  id: string;
};
export type TemplateInputOption = OptionType<false, false, true> & {
  id: string;
};
export type ProductInputOption = OptionType<false, false, false, true> & {
  id: string;
};
export type RecommendationInputOption = OptionType<
  false,
  false,
  false,
  false,
  true
> & {
  id: string;
  itemRecommendationId: string;
  templateId: string;
  templateVersionNumber: number;
};
export type ProductListInputOption = OptionType<
  false,
  false,
  false,
  false,
  false,
  true
> & {
  id: string;
};

export type InputOption =
  | ItemTypeInputOption
  | SearchProductsOption
  | SearchProductsFisSolrOption
  | SearchTemplatesOption
  | SearchProductListsOption
  | PasteOption
  | TemplateOption
  | HeaderInputOption
  | TextInputOption
  | TemplateInputOption
  | ProductInputOption
  | RecommendationInputOption
  | ProductListInputOption;

const ALL_ITEM_TYPES: ReadonlySet<string> = new Set<ItemType>([
  "paid",
  "section",
  "decision",
  "unpaid",
  "defect",
]);

export function isItemTypeOption(option: {
  id: string | ItemType;
}): option is ItemTypeInputOption {
  return ALL_ITEM_TYPES.has(option.id);
}

export function isRecommendationOption(
  option: InputOption | null
): option is RecommendationInputOption {
  return Boolean(option?.isRecommendation);
}
